module.exports = __webpack_public_path__ + "img/17.6824f948.png";